import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { QcResponseGrid } from 'src/app/shared/models/grid.model';
import { IS_SEARCH } from 'src/app/shared/models/load.models';
import { EnvironmentFacadeService } from 'src/app/shared/services/environment.facade.service';
import { LiteralsFacadeService } from 'src/app/shared/services/literals.facade.service';
import { PaginatorFacadeService } from 'src/app/shared/services/paginator.facade.service';
import { TagAssignmentFacadeService } from './tag-assignment.facade.service';

@Injectable({ providedIn: 'root' })
export class SearchTagsAssignmentService {
  constructor(
    private http: HttpClient,
    private environmentFacadeService: EnvironmentFacadeService,
    private tagAssignmentFacadeService: TagAssignmentFacadeService,
    private paginatorFacadeService: PaginatorFacadeService,
    private literalsFacade: LiteralsFacadeService,
  ) {}

  searchTags(): Observable<QcResponseGrid> {
    const url =
      this.environmentFacadeService.getEnvironment() + '/rest/v1/tags/tagged-entities/findByFilter';

    return this.http.post<QcResponseGrid>(
      url,
      {
        criteriaList: [
          {
            criteriaType: 'ESSENTIAL_TAG_CRITERIA',
            tagType: this.tagAssignmentFacadeService.tagType,
          },
          {
            criteriaType: 'BRAND_TAG_CRITERIA',
            brandCode: this.tagAssignmentFacadeService.brandCode,
          },
        ],
        pagination: {
          page: this.paginatorFacadeService.pageIndex + 1,
          pageSize: this.paginatorFacadeService.itemsNumber,
        },
        sorting: {
          sortingField:
            this.paginatorFacadeService.selectedSortField ===
            this.literalsFacade.literals.literals['liquid.search.sort.tags.creation_date']
              ? 'CREATION_DATE'
              : 'CREATION_DATE',
          sortingOrder:
            this.paginatorFacadeService.selectedOrder ===
            this.literalsFacade.literals.literals['liquid.search.sort.asc']
              ? 'ASC'
              : 'DESC',
        },
      },
      { withCredentials: true, context: new HttpContext().set(IS_SEARCH, true) },
    );
  }
}
